'use client';

import { IAuthMeV2OutputDto } from '@quadminds/shared/auth-system';
import { useQueryClient } from '@tanstack/react-query';
import { ChevronRight, HardDrive } from 'lucide-react';
import { useNavigate } from 'react-router-dom';

interface FileBreadcrumbProps {
    currentPath: { id: string; name: string }[];
}

export function FileBreadcrumb({ currentPath = [] }: FileBreadcrumbProps) {
    const queryClient = useQueryClient();
    const navigate = useNavigate();
    const user: IAuthMeV2OutputDto | undefined = queryClient.getQueryData(['userInfo']);

    return (
        <div className="flex items-center text-sm">
            <button
                onClick={() => navigate(`/knowledge/${user?.currentOrganization}`)}
                className="flex items-center hover:text-primary"
                aria-label="Home"
            >
                <HardDrive className="h-4 w-4" />
            </button>

            {currentPath.length > 0 && (
                <>
                    <ChevronRight className="h-4 w-4 mx-1 text-muted-foreground" />
                    {currentPath.map((segment, index) => {
                        const isLast = index === currentPath.length - 1;

                        return (
                            <div key={segment.id} className="flex items-center">
                                <button
                                    onClick={() => navigate(`/knowledge/${segment.id}`)}
                                    className={`hover:text-primary ${isLast ? 'font-medium' : ''}`}
                                >
                                    {segment.name}
                                </button>
                                {!isLast && <ChevronRight className="h-4 w-4 mx-1 text-muted-foreground" />}
                            </div>
                        );
                    })}
                </>
            )}
        </div>
    );
}

export default FileBreadcrumb;
